<template lang="html">
   <div class="typography">
      <div class="row justify-content-center">
         <div class="col-xl-6">
            <div class="small-title">LETTERMARK</div>
            <div class="big-name">{{brand[0]}}<span class="tx-primary">{{brand[1]}}</span></div>

            <div class="color-box">
               <div class="row">
                  <div class="col-md-6 col-lg-3">
                     <div class="color dark">
                        <div class="big">
                           <div class="name">Dark</div>
                           <div class="hex">#0ebdca</div>
                        </div>
                        <div class="row">
                           <div class="col-4 first"><div class="small-box"></div></div>
                           <div class="col-4 second"><div class="small-box"></div></div>
                           <div class="col-4 third"><div class="small-box"></div></div>
                        </div>
                     </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                     <div class="color primary">
                        <div class="big">
                           <div class="name">Primary</div>
                           <div class="hex">#0ebdca</div>
                        </div>
                        <div class="row">
                           <div class="col-4 first"><div class="small-box"></div></div>
                           <div class="col-4 second"><div class="small-box"></div></div>
                           <div class="col-4 third"><div class="small-box"></div></div>
                        </div>
                     </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                     <div class="color secondary">
                        <div class="big">
                           <div class="name">Secondary</div>
                           <div class="hex">#0ebdca</div>
                        </div>
                        <div class="row">
                           <div class="col-4 first"><div class="small-box"></div></div>
                           <div class="col-4 second"><div class="small-box"></div></div>
                           <div class="col-4 third"><div class="small-box"></div></div>
                        </div>
                     </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                     <div class="color color-one">
                        <div class="big">
                           <div class="name">Color One</div>
                           <div class="hex">#0ebdca</div>
                        </div>
                        <div class="row">
                           <div class="col-4 first"><div class="small-box"></div></div>
                           <div class="col-4 second"><div class="small-box"></div></div>
                           <div class="col-4 third"><div class="small-box"></div></div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="colors"></div>
            </div>
         </div>
         <div class="col-xl-5">
            <div class="small-title">TYPOGRAPHY</div>

            <div class="title">Carefully Crafted</div>
            <div class="title light">For Your Needs</div>

            <div class="title-l">
               Laying the foundations for the future,<br>
               One Page at a time.
            </div>

            <div class="title-s">The quick brown fox jumps <br>over the lazy dog</div>

            <div class="text">
               <div class="row">
                  <div class="col-md-6 no-padding">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum corporis officiis, qui maiores fuga libero doloribus iusto 
                     laboriosam laborum ducimus cupiditate dolorem vel dolore,porro doloremque vero. Ipsam, sint perferendis?
                     Quos dolorum laborum eos itaque hic eum esse fuga, soluta dolor iste earum ducimus? Iusto voluptas expedita, 
                     ipsa quia praesentium hic numquam. Repellat fugit tempora doloribus maiores dignissimos totam, molestias architecto, facilis 
                     provident blanditiis laudantium iusto saepe labore vitae qui error, libero sed quidem?
                  </div>
                  <div class="col-md-6 no-padding">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum corporis officiis, qui maiores fuga libero doloribus iusto 
                     laboriosam laborum ducimus cupiditate dolorem vel dolore,porro doloremque vero. Ipsam, sint perferendis?
                     Quos dolorum laborum eos itaque hic eum esse fuga, soluta dolor iste earum ducimus? Iusto voluptas expedita, 
                     ipsa quia praesentium hic numquam. Repellat fugit tempora doloribus maiores dignissimos totam, molestias architecto, facilis 
                     provident blanditiis laudantium iusto saepe labore vitae qui error, libero sed quidem?
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   data(){
      return {
         main_lang,
         brand: []
      }
   },
   mounted(){
      let half = Math.round(main_lang.brand.length / 2)
      this.brand.push(main_lang.brand.substring(0,half),main_lang.brand.substring(half))
      Event.$emit('loader:show',false)
   }
};
</script>

<style lang="scss">
.typography {
   .no-padding{
      padding-left: 0 !important;
   }
   .title-s{
      font-size: 18px;
      line-height: 18px;
      font-weight: 600;
      margin: 70px 0 30px 0;
   }
   .title-l{
      font-size: 24px;
      line-height: 30px;
   }
   .title{
      font-size: 40px;
      line-height: 40px;
      font-weight: 600;
      margin: 40px 0 0 0;

      &.light{
         color: $text-grey;
         margin: 0 0 30px 0;
      }
   }
   .small-title{
      font-weight: 600;
      color: $text-grey;
      font-size: 12px;
      margin: 20px 0;
   }
   .big-name{
      margin: 200px 0;
      text-align: center;
      font-size: 70px;
      font-weight: 600;

      .tx-primary{
         color: $primary;
      }
   }

   .color-box{
      .color{
         
         .col-4{
            padding: 0;
         }
         .small-box{
            width: 100%;
            padding: 15px 0;
         }
         .big{
            border-radius: 5px 5px 0 0;
            position: relative;
            padding: 70px 0;

            .name,.hex{
               position: absolute;
               font-weight: 600;
               font-size: 12px;
               margin: 0 15px;
            }

            .name{
               top: 10px
            }
            .hex{
               bottom: 10px;
            }
            
         }

         &.primary{
            .big{
               background: $primary;
               color: $white;
            }
            
            .col-4{
               &.first{
                  background: $primary-a !important;
                  border-radius: 0 0 0 7px;
               }
               &.second{
                  background: $primary-b !important;
               }
               &.third{
                  background: $primary-c !important;
                  border-radius: 0 0 7px 0;
               }
            }
         }
         &.secondary{
            .big{
               background: $secondary;
               color: $white;
            }
            
            .col-4{
               &.first{
                  background: $secondary-a !important;
                  border-radius: 0 0 0 7px;
               }
               &.second{
                  background: $secondary-b !important;
               }
               &.third{
                  background: $secondary-c !important;
                  border-radius: 0 0 7px 0;
               }
            }
         }
         &.dark{
            .big{
               background: $dark;
               color: $white;
            }
            
            .col-4{
               &.first{
                  background: $dark-a !important;
                  border-radius: 0 0 0 7px;
               }
               &.second{
                  background: $dark-b !important;
               }
               &.third{
                  background: $dark-c !important;
                  border-radius: 0 0 7px 0;
               }
            }
         }
         &.color-one{
            .big{
               background: $color-one;
               color: $white;
            }
            
            .col-4{
               &.first{
                  background: $color-one-a !important;
                  border-radius: 0 0 0 7px;
               }
               &.second{
                  background: $color-one-b !important;
               }
               &.third{
                  background: $color-one-c !important;
                  border-radius: 0 0 7px 0;
               }
            }
         }

      }
   }
}
</style>
